import React from 'react';
import { useLoading } from '../../Context/loadingContext';
import { Icon } from '@iconify/react';

const Loader = () => {
  const { loading } = useLoading();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 rounded-lg bg-white p-8 shadow-xl">
        <div className="relative">
          <Icon
            icon="svg-spinners:ring-resize"
            className="h-12 w-12 text-brand-blue"
          />
        </div>
        <p className="text-sm font-medium text-slate-700">Loading...</p>
      </div>
    </div>
  );
};

export default Loader;
